exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__select-add-multiple___2rSwH.styles__select-add-multiple___2rSwH.styles__select-add-multiple___2rSwH{width:100%}.styles__select-add-multiple-list___2XidG{padding:8px;background-color:#fff}", ""]);

// Exports
exports.locals = {
	"select-add-multiple": "styles__select-add-multiple___2rSwH",
	"select-add-multiple-list": "styles__select-add-multiple-list___2XidG"
};